export default __webpack_public_path__ + "static/media/IMG_9306.ed95e24d.JPG";